import React from "react";
// outsource
import { Row, Col } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";

const PayoutSettingAfterHoursInfoBox = () => {
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="ps-info-box">
        <InfoCircleFilled className="ps-info-icon" />
        <div>
          Set the start time after which after-hours pay applies for each branch.{" "}
          <strong>Weekdays:</strong>{" "}
          <span className="ps-info-highlight">Monday - Friday</span>
          <br />
          The after-hours period starts at the specified time and continues until
          the end of the shift{" "}
          <strong>Weekends:</strong>{" "}
          <span className="ps-info-highlight">Saturday - Sunday</span>
        </div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default PayoutSettingAfterHoursInfoBox;
